import { useSelector } from "react-redux";
import { FirebaseState } from "../../utilities/firebaseState";
import { ProjectState } from "../project/slice";
import { RecordState } from "./slice";

export const useRecordState = () => {
    return useSelector(
        (state: {
            record: RecordState;
            firebase: FirebaseState;
            project: ProjectState;
        }) => state
    );
};
